import React, { useEffect, useRef, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Chip, Grid, IconButton, MenuItem, Modal, Paper, Select, Snackbar, TextField, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import CustomTextField from 'src/components/forms/theme-elements/CustomTextField';
import TextEditor from 'src/components/CustomComponents/TextEditor';
import { EditorState, convertToRaw } from 'draft-js';
import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';
import { AddCircleOutlineRounded, AddCircleOutlined, CloseOutlined, CloseSharp, DeleteOutline } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import { useParams } from 'react-router';


const EditProduct = () => {
    const imageRef1 = useRef()
    const imageRef2 = useRef()
    const imageRef3 = useRef()
    const imageRef4 = useRef()
    const imageRef5 = useRef()
    const imageRef6 = useRef()
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

    const { id } = useParams();

    const { getTopCategories, getAllColors, getAllVarients, editProduct, addVarient, getProductDetail } = useMain();

    const [categoriesList, setCategoriesList] = useState([]);
    const [colorList, setColorList] = useState([]);

    const initialValue = {
        displayName: '',
        description: '',
        product_category: '',
        product_subCategory: '',
        availability: '',
        price: '',
        brand_title: '',
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null,
        image6: null
    };
    const [showPreview, setShowPreview] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMEssage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [formData, setFormData] = useState(initialValue);
    const [addVarientName, setAddVarientName] = useState(false);
    const [varientName, setVarientName] = useState('');
    const [varientList, setVarientList] = useState([{ varient: '', price: '' }]);

    const handleAddVarients = () => {
        setVarientList([...varientList, { varient: '', price: '' }])
    }

    const handleDeleteVarient = (index) => {
        const updatedVariants = [...varientList];
        updatedVariants.splice(index, 1);
        setVarientList(updatedVariants);
    }

    const handleVarientChange = (e, index) => {
        const { name, value } = e.target;
        setVarientList(varientList?.map((v, i) => (i === index ? { ...v, [name]: value } : v)));
    }

    const getData = async () => {
        const res = await getProductDetail(id);
        const { displayName, availability, color, brand_title, product_category, priceVarient, description, product_subCategory } = res?.data?.product;
        setFormData({
            displayName,
            availability,
            brand_title,
            color: color?._id,
            product_subCategory: product_subCategory,
            product_category: product_category?._id,
            description: description
        });
        if (priceVarient !== null && priceVarient?.length > 0)
            setVarientList(priceVarient?.map((p) => {
                return { varient: p?.varient, price: p?.price }
            }))

        const res1 = await getTopCategories();
        setCategoriesList(res1?.data?.categories);

        const res2 = await getAllColors();
        setColorList(res2?.data?.colors);

        // const res3 = await getAllVarients();
        // setVarientList(res3?.data);
    }

    useEffect(() => {
        getData();

        return () => { };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'product_varient') {
            setFormData({ ...formData, [name]: formData.product_varient + ',' + value })
        }
        else
            setFormData({ ...formData, [name]: value });

    };

    const handleImage = (e, img) => {
        const objectUrl = URL.createObjectURL(e.target.files[0]);
        setShowPreview({ ...showPreview, [img]: objectUrl });
        setFormData({ ...formData, [img]: e.target?.files[0] });
    };

    const handleSubmit = async () => {
        const { displayName, availability, color, brand_title, product_category, product_subCategory } = formData;
        if (displayName.trim() === '') return setErrorMessage('Name is Required');
        if (product_category === '') return setErrorMessage('Category is Required');
        if (product_subCategory === '') return setErrorMessage('Subcategory is Required');
        if (color === '') return setErrorMessage('Color is Required');
        if (brand_title === '') return setErrorMessage('Brand is Required');
        if (availability === '') return setErrorMessage('Status is Required');
        if (editorState === '') return setErrorMessage('Description is Required');
        if (formData.image1 === null) return setErrorMessage('Atleast 2 Images are required');
        if (formData.image2 === null) return setErrorMessage('Atleast 2 Images are required');

        const varientErr = varientList.filter((v) => ((v.price !== '' && v.varient === '') || (v.price === '' && v.varient !== '')));
        if (varientErr?.length > 0) {
            return setErrorMessage('Both size and price columns must be field properly');
        }
        const varients = varientList?.map((v) => v.varient).filter((v) => v.length > 0)?.join(',');
        const prices = varientList?.map((v) => v.price).filter((v) => v.length > 0)?.join(',');
        if (varients === '' || prices === '')
            return setErrorMessage('Atleast one varient is required');
        const updatedVarient = varientList?.filter((v) => !(v.price === '' || v.varient === ''))
        const formDataUpdated = new FormData();
        formDataUpdated.append('displayName', displayName);
        formDataUpdated.append('product_category', product_category);
        formDataUpdated.append('product_subCategory', product_subCategory)
        formDataUpdated.append('priceVarient', JSON.stringify(updatedVarient));
        formDataUpdated.append('color', color);
        formDataUpdated.append('brand_title', brand_title);
        formDataUpdated.append('availability', availability);
        formDataUpdated.append('description', editorState);
        formDataUpdated.append('image', formData.image1, formData.image1.name);
        formDataUpdated.append('image', formData.image2, formData.image2.name);
        if (formData?.image3)
            formDataUpdated.append('image', formData.image3, formData.image3.name);
        if (formData?.image4)
            formDataUpdated.append('image', formData.image4, formData.image4.name);
        if (formData?.image5)
            formDataUpdated.append('image', formData.image5, formData.image5.name);
        if (formData?.image6)
            formDataUpdated.append('image', formData.image6, formData.image6.name);
        setShowLoader(true);

        const res = await editProduct(formDataUpdated, id);
        // createBlog(formData, (res) => {
        if (res?.status === 'success') {
            setSuccessMEssage('Product Successfully Created');
            setTimeout(() => {
                setSuccessMEssage('');
            }, 7000);
            setFormData(initialValue);
            setErrorMessage('');
            setEditorState(EditorState.createEmpty());
            setShowLoader(false);
        } else {
            setErrorMessage(res?.error?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            setFormData(initialValue);
            setShowLoader(false);
        }
    };
    return (
        <PageContainer title="Edit Product" description="this is add Product">
            <DashboardCard title="Edit Product">
                <Snackbar
                    open={errorMessage == '' ? false : true}
                    autoHideDuration={6000}
                    onClose={() => {
                        setErrorMessage('');
                    }}
                    severity="error"
                    message={errorMessage}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                />
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Name <ReqField />
                    </Typography>
                    <CustomTextField
                        id="username"
                        variant="outlined"
                        fullWidth
                        value={formData?.displayName}
                        onChange={handleChange}
                        name="displayName"
                    />
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Youtube link <ReqField />
                    </Typography>
                    <CustomTextField
                        id="username"
                        variant="outlined"
                        fullWidth
                        value={formData?.brand_title}
                        onChange={handleChange}
                        name="brand_title"
                    />
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Description <ReqField />
                    </Typography>
                    <div
                        style={{
                            border: '1px solid gray',
                            padding: '10px',
                        }}
                    >
                        <TextEditor
                            convertedContent={editorState}
                            setConvertedContent={setEditorState}
                            setFormData={setFormData}
                            formData={formData}
                        />
                    </div>
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Availability <ReqField />
                    </Typography>
                    <CustomTextField
                        id="username"
                        variant="outlined"
                        fullWidth
                        type={'number'}
                        value={formData?.availability}
                        onChange={handleChange}
                        name="availability"
                    />
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    {/* <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Category <ReqField /> */}
                    {/* <Tooltip title="Add Category">
                            <IconButton color='primary' onClick={() => setAddVarientName(true)}>
                                <AddCircleOutlined />
                            </IconButton>
                        </Tooltip> */}
                    {/* </Typography> */}
                    <Box style={{ marginTop: '20px' }}>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                <Box>
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={600}
                                        component="label"
                                        htmlFor="username"
                                        mb="5px"
                                    >
                                        Category <ReqField />
                                    </Typography>
                                    <Select
                                        fullWidth
                                        labelId="product_category"
                                        id="product_category"
                                        size="medium"
                                        mt="25"
                                        value={formData?.product_category}
                                        name="product_category"
                                        onChange={handleChange}
                                    >
                                        {categoriesList?.map((item, index) => {
                                            return <MenuItem value={item?._id} key={index}>{item?.name}</MenuItem>;
                                        })}
                                    </Select>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box>
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={600}
                                        component="label"
                                        htmlFor="username"
                                        mb="5px"
                                    >
                                        Subcategory <ReqField />
                                    </Typography>
                                    <Select
                                        fullWidth
                                        labelId="product_subCategory"
                                        id="product_subCategory"
                                        size="medium"
                                        mt="25"
                                        value={formData?.product_subCategory}
                                        name="product_subCategory"
                                        onChange={handleChange}
                                    >

                                        {categoriesList?.filter((c) => c?._id === formData?.product_category)[0]?.subCategory?.map((item, index) => {
                                            return <MenuItem value={item} key={index}>{item}</MenuItem>
                                        })}
                                    </Select>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {/* <Select
                        fullWidth
                        labelId="product_category"
                        id="product_category"
                        size="medium"
                        mt="25"
                        value={formData?.product_category}
                        name="product_category"
                        onChange={handleChange}
                    >
                        {categoriesList?.map((item, index) => {
                            return <MenuItem value={item?._id} key={index}>{item?.name}</MenuItem>;
                        })}
                    </Select> */}
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Color <ReqField />
                    </Typography>
                    <Select
                        fullWidth
                        labelId="color"
                        id="color"
                        size="medium"
                        mt="25"
                        value={formData?.color}
                        name="color"
                        onChange={handleChange}
                    >
                        {colorList?.map((item, index) => {
                            return <MenuItem value={item?._id} key={index}>{item?.color_name}</MenuItem>;
                        })}
                    </Select>
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Varient <ReqField />
                        <Tooltip title="Add Varient">
                            <IconButton color='primary' onClick={handleAddVarients}>
                                <AddCircleOutlined />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                    {/* <Box style={{ marginTop: '20px' }}>
                        <Grid container spacing={3}>
                            <Grid item xs={5}>
                                <Box>
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={600}
                                        component="label"
                                        htmlFor="username"
                                        mb="5px"
                                    >
                                        Size (Inch) <ReqField />
                                    </Typography>
                                    <CustomTextField
                                        id="username"
                                        variant="outlined"
                                        fullWidth
                                        type={'number'}
                                        value={formData?.price}
                                        onChange={handleChange}
                                        name="price"
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={5}>
                                <Box>
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={600}
                                        component="label"
                                        htmlFor="username"
                                        mb="5px"
                                    >
                                        Price <ReqField />
                                    </Typography>
                                    <CustomTextField
                                        id="username"
                                        variant="outlined"
                                        fullWidth
                                        type={'number'}
                                        value={formData?.price}
                                        onChange={handleChange}
                                        name="price"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box> */}
                    {
                        varientList?.map((v, index) =>
                            <Box key={index} style={{ marginTop: '20px' }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={5}>
                                        <Box>
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight={600}
                                                component="label"
                                                htmlFor="username"
                                                mb="5px"
                                            >
                                                Size (Inch) {index === 0 && <ReqField />}
                                            </Typography>
                                            <CustomTextField
                                                id="username"
                                                variant="outlined"
                                                fullWidth
                                                type={'number'}
                                                value={v?.varient}
                                                onChange={(e) => handleVarientChange(e, index)}
                                                name="varient"
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Box>
                                            <Typography
                                                variant="subtitle1"
                                                fontWeight={600}
                                                component="label"
                                                htmlFor="username"
                                                mb="5px"
                                            >
                                                Price {index === 0 && <ReqField />}
                                            </Typography>
                                            <CustomTextField
                                                id="username"
                                                variant="outlined"
                                                fullWidth
                                                type={'number'}
                                                value={v?.price}
                                                onChange={(e) => handleVarientChange(e, index)}
                                                name="price"
                                            />
                                        </Box>
                                    </Grid>
                                    {
                                        index !== 0 &&
                                        <Grid item xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                                            <Box>
                                                <Tooltip title="Delete">
                                                    <IconButton color='error' onClick={() => handleDeleteVarient(index)}>
                                                        <DeleteOutline />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </Grid>
                                    }
                                </Grid>
                            </Box>
                        )
                    }
                    {/* <Select
                        fullWidth
                        labelId="size"
                        id="size"
                        size="medium"
                        mt="25"
                        value={formData?.product_varient}
                        name="product_varient"
                        onChange={handleChange}
                    >
                        {varientList.filter((item) => !formData?.product_varient?.split(',')?.includes(item?._id))?.map((item, index) => {
                            return <MenuItem value={item?._id} key={index}>{item?.name}</MenuItem>;
                        })}
                    </Select> */}
                </Box>
                {/* {
                    formData?.product_varient?.length > 0 &&
                    <Box style={{ marginTop: '20px' }}>
                        <Typography
                            variant="subtitle1"
                            fontWeight={600}
                            component="label"
                            htmlFor="username"
                            mb="5px"
                        >
                            Selected sizes:
                        </Typography>
                        {
                            varientList?.filter((item) => formData?.product_varient?.split(',')?.includes(item?._id))?.map((item, index) =>
                                <Chip
                                    sx={{
                                        px: "4px",
                                        mx: "4px",
                                        backgroundColor: 'primary.main',
                                        color: "#fff",
                                    }}
                                    size="small"
                                    key={index}
                                    label={item?.name}
                                ></Chip>
                            )
                        }
                    </Box>
                } */}
                {/* <Modal open={addVarientName} onClose={() => setAddVarientName(false)} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ backgroundColor: 'white', padding: '5px 5px 10px 15px', outline: 'none', minWidth: '350px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <div style={{ fontWeight: "bold" }}>Add Varient</div>
                            <IconButton onClick={() => setAddVarientName(false)}>
                                <CloseSharp />
                            </IconButton>
                        </div>
                        <TextField
                            label="Varient Name"
                            variant="outlined"
                            value={varientName}
                            style={{ marginBottom: '10px', width: '90%' }}
                            onChange={(e) => setVarientName(e.target.value)}
                        />
                        <div>
                            <Button style={{ display: "flex", justifyContent: "flex-end", }} variant="contained" color="primary" onClick={handleAddVarient}>
                                Add
                            </Button>
                        </div>
                    </div>
                </Modal> */}
                {/* <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Price <ReqField />
                    </Typography>
                    <CustomTextField
                        id="username"
                        variant="outlined"
                        fullWidth
                        type={'number'}
                        value={formData?.price}
                        onChange={handleChange}
                        name="price"
                    />
                </Box> */}
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                    >
                        Image1: <ReqField />
                    </Typography>
                    <div onClick={() => imageRef1.current.click()} style={{ cursor: 'pointer', border: '1px solid black', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', borderRadius: '0.4rem', padding: '1rem' }}>
                        <div>
                            <input ref={imageRef1} type="file" onChange={(e) => handleImage(e, 'image1')} />
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            {showPreview?.image1 && <img alt='' height="100px" src={showPreview.image1} />}
                        </div>
                    </div>
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                    >
                        Image2: <ReqField />
                    </Typography>
                    <div onClick={() => imageRef2.current.click()} style={{ cursor: 'pointer', border: '1px solid black', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', borderRadius: '0.4rem', padding: '1rem' }}>
                        <div>
                            <input ref={imageRef2} type="file" onChange={(e) => handleImage(e, 'image2')} />
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            {showPreview?.image2 && <img alt='' height="100px" src={showPreview.image2} />}
                        </div>
                    </div>
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                    >
                        Image3:
                    </Typography>
                    <div onClick={() => imageRef3.current.click()} style={{ cursor: 'pointer', border: '1px solid black', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', borderRadius: '0.4rem', padding: '1rem' }}>
                        <div>
                            <input ref={imageRef3} type="file" onChange={(e) => handleImage(e, 'image3')} />
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            {showPreview?.image3 && <img alt='' height="100px" src={showPreview.image3} />}
                        </div>
                    </div>
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                    >
                        Image4:
                    </Typography>
                    <div onClick={() => imageRef4.current.click()} style={{ cursor: 'pointer', border: '1px solid black', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', borderRadius: '0.4rem', padding: '1rem' }}>
                        <div>
                            <input ref={imageRef4} type="file" onChange={(e) => handleImage(e, 'image4')} />
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            {showPreview?.image4 && <img alt='' height="100px" src={showPreview.image4} />}
                        </div>
                    </div>
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                    >
                        Image5:
                    </Typography>
                    <div onClick={() => imageRef5.current.click()} style={{ cursor: 'pointer', border: '1px solid black', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', borderRadius: '0.4rem', padding: '1rem' }}>
                        <div>
                            <input ref={imageRef5} type="file" onChange={(e) => handleImage(e, 'image5')} />
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            {showPreview?.image5 && <img alt='' height="100px" src={showPreview.image5} />}
                        </div>
                    </div>
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                    >
                        Image6:
                    </Typography>
                    <div onClick={() => imageRef6.current.click()} style={{ cursor: 'pointer', border: '1px solid black', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', borderRadius: '0.4rem', padding: '1rem' }}>
                        <div>
                            <input ref={imageRef6} type="file" onChange={(e) => handleImage(e, 'image6')} />
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                            {showPreview?.image6 && <img alt='' height="100px" src={showPreview.image6} />}
                        </div>
                    </div>
                </Box>

                {showLoader && <ShowLoader value={showLoader} />}
                {successMessage != '' && <ShowSuccess message={successMessage} />}

                <div style={{ width: '60%', margin: 'auto', marginTop: '2rem' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </DashboardCard>
        </PageContainer>
    )
}

export default EditProduct;